module.exports = __webpack_public_path__ + "img/sw1-b5.ae1e55fc.jpg";